export const UPLOAD_IMAGE_REQUEST = '@files/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = '@files/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = '@files/UPLOAD_IMAGE_FAILURE';

export const UPLOAD_MULTI_IMAGE_REQUEST = '@files/UPLOAD_MULTI_IMAGE_REQUEST';
export const UPLOAD_MULTI_IMAGE_SUCCESS = '@files/UPLOAD_MULTI_IMAGE_SUCCESS';
export const UPLOAD_MULTI_IMAGE_FAILURE = '@files/UPLOAD_MULTI_IMAGE_FAILURE';
